import { render, staticRenderFns } from "./share-album.vue?vue&type=template&id=64a25094"
import script from "./share-album.vue?vue&type=script&lang=js"
export * from "./share-album.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports